import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/particles/particles"
 * Contains 6 texture(s)
 */
export class ParticlesAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/particles/particles';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        'spades_face.png',
        'particleStar.png',
        'particleDot.png',
        'hearts_face.png',
        'diamonds_face.png',
        'clubs_face.png'
    ] as const;
}
